$(function () {
  let hoverTimeout;

  // 点击导航项：展开/收起，并控制滚动
  $('.site-nav .site-nav__item').click(function (e) {
    e.stopPropagation();

    
    const isProducts = $(this).hasClass('site-nav__products');
    const isActive = $(this).hasClass('site-nav__item__active');

    // $('.site-nav .site-nav__item').removeClass('site-nav__item__active');
   $('.site-nav .site-nav__item').removeClass('site-nav__item__active');
   $('.site-nav .first-product-nav--active').removeClass('first-product-nav--active');
    if (!isActive) {
      $(this).addClass('site-nav__item__active');
    }

    if (isProducts) {
        $(this).find('.first-product-link').first().addClass('first-product-nav--active');
    }
  });

  // 点击导航区域非导航项部分：关闭菜单
  $('.site-header').click(function (e) {
    if (!$(e.target).closest('.site-nav__item').length) {
      $('.site-nav .site-nav__item').removeClass('site-nav__item__active');
    }
  });

  // 按下 ESC 键：关闭菜单
  $(document).on('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && $('.site-nav .site-nav__item__active').length) {
      $('.site-nav .site-nav__item').removeClass('site-nav__item__active');
    }
  });

  // 鼠标移出 meganav 区域：关闭菜单
  $('.site-nav .meganav').on('mouseleave', function () {
   $('.site-nav .site-nav__item').removeClass('site-nav__item__active');
   $('.site-nav .first-product-nav--active').removeClass('first-product-nav--active');
  });

  // 一级导航 hover 切换图像与高亮
  $(".first-product-link").hover(
    function () {
      const $this = $(this);
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(function () {
        $(".mega-link li").removeClass("first-product-nav--active second-product-nav--active");
        $this.addClass("first-product-nav--active");

        let coverImg = $this.data("nav-cover");
        if (coverImg) {
          $("#nav_image-content__image").fadeOut(30, function () {
            $(this).attr("src", coverImg).fadeIn(30);
          });
        }
      }, 30);
    },
    function () {
      clearTimeout(hoverTimeout);
    }
  );

  // 二级导航 hover 高亮
  $(".second-product-link").hover(
    function () {
      const $this = $(this);
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(function () {
        $(".second-product-link").removeClass("second-product-nav--active");
        $this.addClass("second-product-nav--active");
      }, 30);
    },
    function () {
      clearTimeout(hoverTimeout);
    }
  );

  // 移动端防止滚动穿透（可选）
  $('.meganav').on('touchmove', function (e) {
    e.preventDefault();
  }, { passive: false });
});
